/** Workflow and direct-notification event types safe for the HR worker surface. */
export const HR_NOTIFICATION_WORKFLOW_TYPES = [
  'PROTECTED_DISCLOSURE_MONTHLY_WELCOME',
  'LEAVE_REQUEST',
  'LEAVE_WITHDRAW',
  'WORKFORCE_COMPLIANCE',
  'WORKFORCE_POLICY_ASSIGNED',
  'WORKFORCE_POLICY_REMINDER',
  'WHS_INCIDENT',
  'SHIFT_OFFER',
  'SHIFT.ASSIGNED',
  'WORKFORCE_TIMESHEET_CORRECTION_PROPOSED',
  'WORKFORCE_WORKED_TIME_PARTIALLY_APPROVED',
  'TIMESHEET_REJECTED',
  'STAFF_PAY_DOCUMENT_AVAILABLE',
] as const;

/** Safe, plain-English labels for workforce inbox rows. */
export const HR_NOTIFICATION_TITLES: Record<
  (typeof HR_NOTIFICATION_WORKFLOW_TYPES)[number],
  string
> = {
  PROTECTED_DISCLOSURE_MONTHLY_WELCOME: 'Protected disclosures are welcome',
  LEAVE_REQUEST: 'Leave request update',
  LEAVE_WITHDRAW: 'Leave withdrawal update',
  WORKFORCE_COMPLIANCE: 'Work readiness update',
  WORKFORCE_POLICY_ASSIGNED: 'New workplace policy',
  WORKFORCE_POLICY_REMINDER: 'Workplace policy reminder',
  WHS_INCIDENT: 'Workplace safety update',
  SHIFT_OFFER: 'New shift offer',
  'SHIFT.ASSIGNED': 'Shift update',
  WORKFORCE_TIMESHEET_CORRECTION_PROPOSED: 'Timesheet correction proposed',
  WORKFORCE_WORKED_TIME_PARTIALLY_APPROVED: 'Some of your time was approved',
  TIMESHEET_REJECTED: 'Timesheet update',
  STAFF_PAY_DOCUMENT_AVAILABLE: 'Pay document available',
};

const hrNotificationWorkflowTypes = new Set<string>(HR_NOTIFICATION_WORKFLOW_TYPES);

export function isHrNotificationWorkflowType(value: unknown): boolean {
  return typeof value === 'string' && hrNotificationWorkflowTypes.has(value.trim().toUpperCase());
}
